import { z } from 'zod';

// TODO: refine after Data Structure doc review
// Cross-service event payloads. Anything that crosses a process boundary
// gets a Zod schema here.

export const MilestoneEventPayloadSchema = z.object({
  gameId: z.string().uuid(),
  milestoneId: z.string().uuid(),
  buildMarkerId: z.string().uuid().nullable(),
  playerTokenId: z.string().uuid().nullable(),
  triggeredAt: z.string().datetime({ offset: true }),
  context: z.record(z.unknown()).optional(),
});
export type MilestoneEventPayload = z.infer<typeof MilestoneEventPayloadSchema>;

export const DmDispatchPayloadSchema = z.object({
  dispatchId: z.string().uuid(),
  playerTokenId: z.string().uuid(),
  templateKey: z.string().min(1),
  variables: z.record(z.string()).default({}),
  scheduledAt: z.string().datetime({ offset: true }),
});
export type DmDispatchPayload = z.infer<typeof DmDispatchPayloadSchema>;

export const PairRequestPayloadSchema = z.object({
  pairingCodeId: z.string().uuid(),
  gameId: z.string().uuid(),
  installId: z.string().nullable(),
  requestedAt: z.string().datetime({ offset: true }),
});
export type PairRequestPayload = z.infer<typeof PairRequestPayloadSchema>;
